module.exports = __webpack_public_path__ + "img/computer-bg.15dc109d.png";